import { observer } from 'mobx-react-lite';

import { Grid, Typography } from '@mui/material';
import ContactCard from '../components/cards/ContactCard';
import GridContainer from '../components/container/GridContainer';
import EmergencyContactsCard from '../components/EmergencyContacts/EmergencyContactsCard';
import Config from '../config';
import { useStore } from '../store/context';

const ContactsPage = observer((): JSX.Element => {
  const { welcomeStore } = useStore();
  const welcomeData = welcomeStore.getWelcomeData();

  const configuration = Config[process.env.REACT_APP_CLIENT || 'wbg'];
  const currentIds = configuration.hba_ids;

  const emergencyContacts =
    welcomeData?.emergencyContacts &&
    welcomeData?.emergencyContacts.filter(
      emergencycontact => emergencycontact.user_art_id === '9',
    );

  return (
    <GridContainer>
      <Grid
        container
        paddingTop={3}
        direction="row"
        alignItems="center"
        justifyContent="center"
      >
        {welcomeData?.contacts
          ?.filter(contact => currentIds.includes(contact.user_art_id ?? ''))
          .sort(
            (a, b) => Number(a.user_art_id ?? 0) - Number(b.user_art_id ?? 0),
          )
          .map(contact => (
            <Grid item key={contact.kont?.telnr}>
              <ContactCard
                contact={contact}
                iconCenter
                iconOn
                iconColor="secondary.main"
                width={400}
                height={250}
              />
            </Grid>
          ))}
      </Grid>
      {emergencyContacts && emergencyContacts?.length > 0 && (
        <>
          <hr style={{ color: '#58585A', width: '80%', marginTop: 8 }} />
          <Typography
            variant="h4"
            sx={{ textAlign: 'center', color: '#58585A', marginTop: 4 }}
          >
            Notfallnummern
          </Typography>
          <Grid
            container
            paddingTop={3}
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
            {emergencyContacts.map(emergencyContact => (
              <Grid item key={emergencyContact.kont?.telnr}>
                <EmergencyContactsCard
                  emergencyContact={emergencyContact}
                  iconCenter
                />
              </Grid>
            ))}
          </Grid>
        </>
      )}
    </GridContainer>
  );
});

export default ContactsPage;
